<template>
  <gg-card>
    <gg-card-header>
      Contact Information
    </gg-card-header>
    <gg-card-text>
      <v-row>
        <v-col cols="12">
          <p class="mb-2">
            Enter the contact information for your {{ websitetype }}.
          </p>
        </v-col>
        <v-col cols="12" md="6">
          <gg-text-field
            v-model="email"
            name="email"
            label="Email Address"
            autocomplete="new-password"
            data-vv-as="Email Address"
            v-validate="'email'"
            :error-messages="errors.collect('email')"
          />
        </v-col>
        <v-col cols="12" md="6">
          <gg-text-field
            v-model="phone"
            label="Phone Number"
            name="phone"
            autocomplete="new-password"
            data-vv-as="Phone Number"
            v-validate="'phone'"
            :error-messages="errors.collect('phone')"
          />
        </v-col>
        <v-col cols="12" md="6">
          <gg-text-field
            v-model="facebook"
            label="Facebook Link"
            name="facebook"
          />
        </v-col>
        <v-col cols="12" md="6">
          <gg-text-field
            v-model="twitter"
            label="Twitter Link"
            name="twitter"
          />
        </v-col>
        <v-col cols="12" md="6">
          <gg-text-field
            v-model="instagram"
            label="Instagram Link"
            name="instagram"
          />
        </v-col>
        <v-col cols="12" md="6">
          <gg-text-field
            v-model="linkedin"
            label="LinkedIn Link"
            name="linkedin"
          />
        </v-col>
      </v-row>
    </gg-card-text>
  </gg-card>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

const phoneValidator = {
  getMessage (field) {
    return `The ${field} must be a valid phone number`
  },
  validate (val) {
    const phoneRegex = /^\(?([0-9]{0,3})\)?([ .-]?)([0-9]{3})\2([0-9]{4,6})$/
    return phoneRegex.test(val)
  }
}

export default {
  name: 'ContactInfo',
  data () {
    return {}
  },
  computed: {
    ...mapGetters({
      starterSite: 'wizard_model/starterSite'
    }),
    websitetype: {
      get () {
        return this.starterSite.website_type !== 'Other' ? this.starterSite.website_type : 'Other Website'
      }
    },
    email: {
      get () {
        return this.starterSite.companyEmail
      },
      set (val) {
        this.SET_SS_COMPANY_EMAIL(val)
      }
    },
    phone: {
      get () {
        return this.starterSite.companyPhone
      },
      set (val) {
        this.SET_SS_COMPANY_PHONE(val)
      }
    },
    facebook: {
      get () {
        return this.starterSite.socialFacebook
      },
      set (val) {
        this.SET_SS_FACEBOOK(val)
      }
    },
    twitter: {
      get () {
        return this.starterSite.socialTwitter
      },
      set (val) {
        this.SET_SS_TWITTER(val)
      }
    },
    instagram: {
      get () {
        return this.starterSite.socialInstagram
      },
      set (val) {
        this.SET_SS_INSTAGRAM(val)
      }
    },
    linkedin: {
      get () {
        return this.starterSite.socialLinkedIn
      },
      set (val) {
        this.SET_SS_LINKEDIN(val)
      }
    },
  },
  methods: {
    ...mapMutations({
      SET_SS_COMPANY_EMAIL: 'wizard_model/SET_SS_COMPANY_EMAIL',
      SET_SS_COMPANY_PHONE: 'wizard_model/SET_SS_COMPANY_PHONE',
      SET_SS_FACEBOOK: 'wizard_model/SET_SS_FACEBOOK',
      SET_SS_TWITTER: 'wizard_model/SET_SS_TWITTER',
      SET_SS_INSTAGRAM: 'wizard_model/SET_SS_INSTAGRAM',
      SET_SS_LINKEDIN: 'wizard_model/SET_SS_LINKEDIN',
    }),
    validate () {
      return this.$validator.validateAll()
    }
  },
  mounted () {
    this.$validator.extend('phone', phoneValidator)
  }
}
</script>

<style scoped>

</style>
